import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNav from './BottomNav'

export default function Layout() {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)
  const location = useLocation()

  // Show bottom nav on main pages and detail pages (exact match)
  // Show on: /, /traffic, /statistics, /profile, /bots/:id (exact), /traffic/:id (exact)
  // Hide on: all settings sub-pages like /bots/:id/timeout, /traffic/:id/token, etc.
  const showOnPaths = ['/', '/traffic', '/shows', '/statistics', '/profile', '/resources']
  const isExactBotDetails = /^\/bots\/[^/]+$/.test(location.pathname)
  const isExactResourceDetails = /^\/traffic\/[^/]+$/.test(location.pathname)

  const hideBottomNav = !showOnPaths.includes(location.pathname) &&
                        !isExactBotDetails &&
                        !isExactResourceDetails

  // Reset keyboard state when location changes (safety net)
  useEffect(() => {
    setIsKeyboardOpen(false)
  }, [location.pathname])

  useEffect(() => {
    // Listen for focus on input fields - instant hide
    const handleFocus = (e: FocusEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        // Hide menu instantly when input is focused
        setIsKeyboardOpen(true)
      }
    }

    const handleBlur = (e: FocusEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        // Check if another input got focus
        requestAnimationFrame(() => {
          const activeElement = document.activeElement
          if (!(activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement)) {
            setIsKeyboardOpen(false)
          }
        })
      }
    }

    // Safety check: periodically verify keyboard state matches reality
    const intervalId = setInterval(() => {
      const activeElement = document.activeElement
      const shouldBeOpen = activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement
      setIsKeyboardOpen(shouldBeOpen)
    }, 1000)

    document.addEventListener('focusin', handleFocus, { capture: true })
    document.addEventListener('focusout', handleBlur, { capture: true })

    return () => {
      clearInterval(intervalId)
      document.removeEventListener('focusin', handleFocus, { capture: true })
      document.removeEventListener('focusout', handleBlur, { capture: true })
    }
  }, [])

  return (
    <div className="flex flex-col min-h-screen bg-tg-bg">
      <main className="flex-1 pb-48 bg-tg-bg">
        <Outlet />
      </main>
      {!hideBottomNav && <BottomNav isVisible={!isKeyboardOpen} />}
    </div>
  )
}
